import React from 'react';
import { PluginType, type IExportPlugin } from '@/version-types';

const VectorLayerShortcutMenuView: React.FC = React.memo(() => {
    return null;
});

const exportPlugin: IExportPlugin = {
    type: PluginType.SYSTEM,
    sort: 1,
    name: 'vector-layer-shortcut-menu',
    render() {
        return <VectorLayerShortcutMenuView />;
    },
};

export default exportPlugin;
